import { VabsPaymentDirection } from '@/shared/api';
import { Plus, SendIcon } from '@/shared/assets';

export const PAYMENT_INDICATORS: Record<VabsPaymentDirection, React.ReactNode> =
  {
    [VabsPaymentDirection.Incoming]: <Plus className="h-full w-full" />,
    [VabsPaymentDirection.Outgoing]: <SendIcon className="h-3 w-3" />,
    [VabsPaymentDirection.Both]: <></>,
  };
